module.exports = "/assets/data/3751d34f8ca4b2ac2503f468067e774f-CB11.data.json";